import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Link, Stack, TextField, Typography } from "@mui/material"
import { useFormik } from "formik"
import * as yup from "yup"
import FileUploadField from "../../../components/FileUploadField"
import React from "react"

const LessonMaterialForm = ({ data, open, onClose, onSave, onAddFiles, acceptedFiles, onRemoveAcceptedFile, currentLesson, }) => {

    const initialValues = React.useMemo(() => ({ ...data, lesson: data?.lesson ?? currentLesson?.id ?? null }), [data, currentLesson])

    const { values, errors, touched, handleChange, handleSubmit } = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema: yup.object({
            name: yup.string().required(),
            comment: yup.string()
        }),
        onSubmit: onSave
    })

    if (!data || !values?.lesson) return null

    return <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
        <DialogTitle>
            Прикрепление материалов для занятия
        </DialogTitle>
        <DialogContent>
            <TextField
                id="name"
                name="name"
                label="Название материала"
                fullWidth
                value={values.name}
                onChange={handleChange}
                required
                error={touched.name && Boolean(errors.name)}
            />
            <TextField
                id="comment"
                name="comment"
                label="Комментарий"
                fullWidth
                value={values.comment}
                onChange={handleChange}
                multiline
                minRows={4}
                maxRows={8}
                error={touched.comment && Boolean(errors.comment)}
            />

            {data.files?.length > 0 && <Stack sx={{ mt: 2 }} spacing={1}>
                <Typography variant="h6">
                    Прикрепленные файлы
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Stack direction="column">
                    {data.files.map(file => <Link key={file.id} href={file.link}>{file.name}</Link>)}
                </Stack>
            </Stack>}

            <FileUploadField
                onDrop={onAddFiles}
                acceptedFiles={acceptedFiles ?? []}
                onRemoveAcceptedFile={onRemoveAcceptedFile}
                nameGetter={x => x.name}
                typeGetter={x => x.type}
            />
        </DialogContent>
        <DialogActions>
            <Button onClick={handleSubmit}>
                Сохранить
            </Button>
            <Button onClick={onClose} color="error">
                Закрыть
            </Button>
        </DialogActions>
    </Dialog>
}

export default LessonMaterialForm